import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./Spinner.css";
const Spinner = ({ text }) => {
    return (_jsxs("div", Object.assign({ className: "fixed z-50 w-full h-full flex flex-col justify-center items-center" }, { children: [_jsx("div", { className: "loader" }), text && _jsx("div", Object.assign({ className: "spinner-text mt-4" }, { children: text }))] })));
};
export default Spinner;
